/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PecegepayCreditcardExternalIdexternal200,
  GetApiV1PecegepayCreditcardExternalIdexternal401,
  GetApiV1PecegepayCreditcardExternalIdexternal404,
  GetApiV1PecegepayCreditcardExternalIdexternal500,
  GetApiV1PecegepayCreditcardExternalIdexternalPathParams,
  GetApiV1PecegepayCreditcardExternalIdexternalQueryResponse,
} from "../../types/pecegePayCreditCardController/GetApiV1PecegepayCreditcardExternalIdexternal.ts";
import { creditCardOrderResponseViewModelSchema } from "../creditCardOrderResponseViewModelSchema.ts";

export const getApiV1PecegepayCreditcardExternalIdexternalPathParamsSchema =
  z.object({
    idExternal: z.string(),
  }) as unknown as ToZod<GetApiV1PecegepayCreditcardExternalIdexternalPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PecegepayCreditcardExternalIdexternal200Schema = z.lazy(
  () => creditCardOrderResponseViewModelSchema,
) as unknown as ToZod<GetApiV1PecegepayCreditcardExternalIdexternal200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PecegepayCreditcardExternalIdexternal401Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayCreditcardExternalIdexternal401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PecegepayCreditcardExternalIdexternal404Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayCreditcardExternalIdexternal404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PecegepayCreditcardExternalIdexternal500Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayCreditcardExternalIdexternal500>;

export const getApiV1PecegepayCreditcardExternalIdexternalQueryResponseSchema =
  z.lazy(
    () => getApiV1PecegepayCreditcardExternalIdexternal200Schema,
  ) as unknown as ToZod<GetApiV1PecegepayCreditcardExternalIdexternalQueryResponse>;
